import { render, staticRenderFns } from "./class-jiading.vue?vue&type=template&id=9aeb2bcc&scoped=true&"
import script from "./class-jiading.vue?vue&type=script&lang=js&"
export * from "./class-jiading.vue?vue&type=script&lang=js&"
import style0 from "./class-jiading.vue?vue&type=style&index=0&id=9aeb2bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aeb2bcc",
  null
  
)

export default component.exports